import { useRef } from 'react';

import {
  useLegalClientCompleteHeadOnboarding,
  useLegalClientHeadSaveHeadPosition,
} from 'api/requests';
import { useFilesUpload } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { HeadPositionFormType } from 'modules/onboarding/common/forms/headPositionForm';
import {
  getSubmitData,
  getInitialData,
} from 'modules/onboarding/common/helpers/headPosition';

import { useOnboardingContext } from './useOnboardingContext';

export const useHeadPosition = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { t } = useTranslation();

  const {
    error,
    loading: submitLoading,
    saveHeadPosition,
  } = useLegalClientHeadSaveHeadPosition();

  const { complete } = useLegalClientCompleteHeadOnboarding();

  const initialData = useRef(
    getInitialData(
      t,
      data.legalClientHead.legalClientBodies,
      data.legalClientHead.isFirstHead,
      data.legalClientHead.position
    )
  ).current;

  const initialValues = useRef(initialData?.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData.files);

  const onSubmit = async (values: HeadPositionFormType) => {
    if (values) {
      const submitData = getSubmitData(values);

      await saveHeadPosition(
        data.legalClient.id,
        data.legalClientHead.id,
        submitData
      );

      // complete when the organ has been restored
      if (data.legalClientHead?.pepConnection?.relation) {
        complete(data.legalClient.id, data.legalClientHead.id);
      }

      goToNext();
    }
  };

  return {
    onSubmit,
    goToBack,
    bodies: data.legalClient.bodies,
    submitLoading,
    initialValues,
    error,
    files,
    onAddFiles,
    onRemoveFile,
    submitDisabled,
  };
};
